var React = require('react');

function InstagramInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","fillRule":"evenodd"},[React.createElement("path",{"d":"M23 17.088C23 20.353 20.274 23 16.911 23H7.09C3.726 23 1 20.353 1 17.088V6.912C1 3.647 3.726 1 7.089 1h9.822C20.274 1 23 3.647 23 6.912v10.176z","stroke":"currentColor","fill":"none","key":0}),React.createElement("path",{"d":"M16.998 12.001C16.938 14.761 14.76 17 12 17a5 5 0 0 1-5-4.999c0-2.76 2.24-5.08 5-4.999 3.361.098 5.059 2.248 4.998 4.999z","stroke":"currentColor","fill":"none","key":1}),React.createElement("path",{"d":"M20 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0","fill":"currentColor","key":2})]));
}

InstagramInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = InstagramInline;

InstagramInline.default = InstagramInline;
